import type { QuestionnaireRevisionContext } from '@gcv/shared';
import { QuestionnaireStatus } from '@gcv/shared';

export const hasResubmittedRevisions = (history: QuestionnaireRevisionContext[] | undefined): boolean => {
  if (!history?.length) return false;
  return history.every((entry) => entry.status === QuestionnaireStatus.Completed);
};
